export enum ChartType {
  LINE = "line",
  BAR = "bar",
}

export type RecyclingRatePoint = {
  label: string;
  rate: number;
  prevYearRate?: number;
  portfolioAverage?: number;
};
